import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { Fragment } from 'react';
import colors from '/@/components/theme-provider/colors';
import useIsMobile from '/@/utils/hooks/is-mobile';

const ButtonShowSidebar = ({ children, onClick, showButton, expand }) => {
    const isMobile = useIsMobile();
    return (
        <Fragment>
            {children}
            {showButton && !isMobile && (
                <Box sx={{ width: 0 }}>
                    <IconButton
                        aria-label='expand'
                        onClick={onClick}
                        size='small'
                        sx={{
                            bgcolor: colors.gray.default,
                            color: 'white',
                            '&:hover': {
                                bgcolor: colors.gray[500],
                                color: 'black',
                            },
                            boxShadow: 1,
                            position: 'relative',
                            zIndex: 10,
                            left: '-15px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                        }}
                    >
                        {expand ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                    </IconButton>
                </Box>
            )}
        </Fragment>
    );
};

export default ButtonShowSidebar;
